import Footer from "components/Footer"
import Navbar from "components/Navbar"
import SignInForm  from "components/SignInForm"

export default function Login() {
    return (
      
      <div className="w-full bg-gray-300">
          <div className="container-xs py-6 md:px-5">
            <Navbar />
          </div>

        <div className="relative h-[780px] bg-gray-300">
          <div className="flex items-center justify-center py-20 w-screen">
              <SignInForm signInMessage="Sign in to your account" className="w-[25%] max-w-[450px]"/>
          </div>
        </div>

        <div>
          <Footer />
        </div>
      </div>
    )
}